module.exports = __webpack_public_path__ + "img/tema-1-1.99f77f71.svg";